import { Children, useEffect, useState } from "react";
import { Chip } from "@mui/material";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { ModalDeleteCore, TableCore, TdCore, } from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  CheckIcon,
  CloseIcon,
  Visibility,
  ModeEditIcon,
  FolderOffIcon,
  FolderCopyIcon,
  DeleteForeverIcon,
  InfoOutlinedIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FilterSidebarComissaoCorretora } from "../FilterSidebar/FilterSidebar";
import { ModalChangeIsActive } from "../ModalChangeIsActive/ModalChangeIsActive";
import { ModalViewComissãoCorretora } from "../ModalComissaoCorretora/Index";

import { UseGetByIdComissaoCorretora } from "./Hooks/UseGetByIdComissaoCorretora";
import { useHttpTableComissaoCorretora } from "./Hooks/useHttpTableComissaoCorretora";
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import { THeadComissaoCorretora } from "./THead";
import { UrlConfig } from "src/shared/Utils/paths";
import { ModalComissaoCorretora } from "../Form";
import { useLocation } from "react-router-dom";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { CustomTabs } from "src/Pages/components/CustomTabs/CustomTabs";

export const TableComissaoCorretora = () => {
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { valuesFilterComissaoCorretora } = useContextComissoes();
  const { valueAutoCompOperadoraFilter } = UseAutoCompletedAll();
  const { handleGetById } = UseGetByIdComissaoCorretora();
  const { listComissaoCorretora } = useContextComissoes();
  const { handleGet } = useHttpTableComissaoCorretora();

  const [openModalComissao, setOpenModalComissao] = useState(false);
  const [openModalChangeIsActive, setOpenModalChangeIsActive] = useState(false);

  const [stateIsActiveComissao, setIsActiveComissao] = useState<
    boolean | undefined
  >();

  const [idModalCommission, setIdModalCommission] = useState<string>("");

  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const { pathname } = useLocation();
  const urlProdutor = UrlConfig.comissao.produtor.url;

  const currentUrl = pathname !== urlProdutor ? "1" : "2";

  const [value, setValue] = useState(currentUrl);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: "Comissão Corretora",
      value: "1",
      to: UrlConfig.comissao.corretora.url,
    },
    {
      label: "Comissão Produtor",
      value: "2",
      to: UrlConfig.comissao.produtor.url,
    },
  ];

  useEffect(() => {
    handleGet({
      itensPerPage,
      currentPage,
      nameSearch,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      isActive: valuesFilterComissaoCorretora.isActive,
    });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const [openModalComissaoCorretora, setOpenModalComissaoCorretora] = useState(false);

  const handleGetIdToEdit = (id: string) => {
    setId(id);
    handleGetById(id);
    setOpenModalComissaoCorretora(true)
  };

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/comissoes/corretora" });

  return (
    <TableCore
      Modals={
        <>
          <ModalViewComissãoCorretora
            id={idModalCommission}
            open={openModalComissao}
            setId={setIdModalCommission}
            setOpen={setOpenModalComissao}
          />

          <ModalChangeIsActive
            isActive={stateIsActiveComissao}
            modalDelete={openModalChangeIsActive}
            setModalDelete={setOpenModalChangeIsActive}
          />

          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
        </>
      }
      tab={
        <CustomTabs
          tabs={tabs}
          currentValue={value}
          onChange={handleChange}
        />
      }
      THead={<THeadComissaoCorretora />}
      filter={<FilterSidebarComissaoCorretora />}
      qtdList={listComissaoCorretora.length}
      setNameSearch={setNameSearch}
      cardAdd={{
        title: "Comissão da Corretora",
        subTitle: "Configure as comissões que a Corretora Recebe.",
        icon: <PriceChangeIcon color="primary" />,
        buttonAdd: [
          <ModalComissaoCorretora
            key={1}
            openModal={openModalComissaoCorretora}
            setOpenModal={setOpenModalComissaoCorretora}
          />,
        ],
      }}
    >
      {Children.toArray(
        listComissaoCorretora.map((item) => {
          return (
            <TableRowCore id={item.code}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <ModeEditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_CORRETORA.EDITAR.id
                        ),
                        onClick: () => {
                          handleGetIdToEdit(item.code);
                        },
                      },
                      {
                        title: item.is_active
                          ? "Desativar grade"
                          : "Ativar grade",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_CORRETORA.EDITAR.id
                        ),

                        onClick: () => {
                          setId(item.code);
                          setOpenModalChangeIsActive(true);
                          setIsActiveComissao(!item.is_active);
                        },
                        icon: item.is_active ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_CORRETORA.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore values={<Chip label={`${item.code}`} sx={{ padding: "0 6px" }} />} />

              <TdCore
                values={<ButtonCore
                  title="Ver comissão"
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setIdModalCommission(item.code);
                    setOpenModalComissao(true);
                  }}
                />}
              />

              <TdCore values={`${item.operadora_code} - ${item.operadora_name}`} />

              <TdCore values={item.administradora_code && `${item.administradora_code} - ${item.administradora_name}`} />

              <TdCore values={`${item.modalidade_code} - ${item.modalidade_name}`} />

              <TdCore
                textAlign="center"
                values={item.vitalicio &&
                  <Chip variant="outlined" label={("Começa na " + (item.vitalicio || "NONE") + "ª parcela")} />
                }
              />
              <TdCore
                borderBottom={`1px solid #0e6aff`}
                color="#0e6aff"
                textAlign="center"
                values={FormatDateBR(
                  handleFormatDateIfIsNull(item.date_vigencia)
                )}
              />
              <TdCore
                textAlign="center"
                values={
                  item.is_active ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />
              <TdCore
                textAlign="center"
                tooltip={`Usuário com id: '${item.id_user_create
                  }' criou na data: ${FormatDateBR(item.created_at)}
                / Usuário com id '${item.id_user_update
                  }' Editou na data: ${FormatDateBR(item.update_at)}`}
                values={<InfoOutlinedIcon />}
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
